module.exports = __webpack_public_path__ + "img/36x34x72-Kit.7f54ac90.png";